import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useApplicationState } from '@atlas/core';

export const AuthorizedRedirect = ({ to = '/' }) => {
  const { authenticated, resolved } = useApplicationState();

  if (resolved && authenticated) {
    return <Redirect to={to} />;
  }

  return null;
};

AuthorizedRedirect.propTypes = {
  to: PropTypes.string,
};

export const NotAuthorizedRedirect = ({ to = '/' }) => {
  const { authenticated, resolved } = useApplicationState();

  if (!resolved || authenticated) {
    return null;
  }

  return <Redirect to={to} />;
};

NotAuthorizedRedirect.propTypes = {
  to: PropTypes.string,
};
